export const ROUTES_URL = {
    HOME: '/',
    LOGIN: '/login',
    UNIVERSIDADES: {
        BUSQUEDA: '/universidades',
        DETALLE: id => `/universidades/${id}`,
    },
    PROGRAMAS: {
        BUSQUEDA: '/programas',
        DETALLE: (id, idUniversidad) => `/programas/${id}/entidad/${idUniversidad}`,
    },
    COMPARADOR: {
        PROGRAMA: '/comparador/programa',
        UNIVERSIDAD: '/comparador/universidad'
    },
    COMUNIDAD: {
        ESTUDIANTIL: '/comunidad/estudiantes',
        DOCENTES: '/comunidad/docentes',
    },
    ABOUT: '/about',
    INFORMACION_COMUNIDAD: '/informacion-comunidad'
    ,
    PUBLICACIONES: '/publicaciones',
}